import React from 'react';

class CardSelector extends React.PureComponent {

    constructor(props) {

        super(props);

        this.handleCardClick = this.handleCardClick.bind(this);
    }

    handleCardClick(card) {

        if (this.props.onCardChange)
            this.props.onCardChange(Object.assign({}, card, {selected: !card.selected}));
    }

    render() {

        return (

            <div className="card-selector">
                {this.props.cards.map(card => (

                    <div key={card.text}
                         tabIndex="0"
                         className={`card ${card.selected ? 'text-green' : 'text-primary'} ${card.selected ? 'border-primary' : ''}`}
                         onClick={() => this.handleCardClick(card)}
                         onKeyUp={(e) => {

                             if (e.keyCode === 32) {

                                 e.preventDefault();
                                 this.handleCardClick(card);
                             }
                         }}>
                        <div className="card-body d-flex flex-column align-items-center">
                            <img src={card.selected ? card.imageSelected : card.image} alt="" className="img-fluid" style={{width: '1.5rem', height: '1.5rem'}}/>
                            <span className="small text-center">{card.text}</span>
                        </div>
                    </div>
                ))}
            </div>
        );
    }
}

export default CardSelector;



// WEBPACK FOOTER //
// ./src/components/CardSelector.js